import ABaseComponent from '../../../ABaseComponent';
import { Table } from 'antd';
const  AntdColumn = Table.Column;
// 表格
export default class Column extends ABaseComponent{
	
	constructor(props){
 		super(props);
		 this.state={
			 ...this.props
		 }
		 this.id=this.props.id
		 this.onCell=this.onCell.bind(this)
		 this.changeTitle=this.changeTitle.bind(this)
 	}
	
	componentDidMount() {
		super.componentDidMount(this);
	}
	onCell = (record,recordIndex)=>{
		if(this.props.onCell){
			return this.props.onCell(record,recordIndex,this.props.dataIndex)
		}
	}
	changeTitle=(title)=>{
		this.setState({title:title})
	}
	createContent() {
		return (
			<AntdColumn  {...this.state} onCell={this.onCell}/>
				//title="First Name"     dataIndex="firstName"       key="firstName"	 
		);
	}
}
